<template>
  <div>
    <PageAllow controller="StockAreas" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet
        v-show="!currentItemMode"
        class="overflow-y-scroll fill-content-height"
      >
        <v-row dense class="mx-5">
          <v-col cols="4" sm="12" md="4">
            <SearcherKeyword
              ref="keyword"
              v-model="options.keyword"
              @text="keyword = $event"
              :label="$t('StockArea.stockAreasKeyword')"
            />
          </v-col>
          <v-col cols="4" sm="12" md="4" align-self="center">
            <v-row dense align="center">
              <v-spacer />
              <v-btn
                v-if="$permission.permissionAllow('StockAreas', 'add')"
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("StockArea.ObjectName")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <div class="mx-4 my-4">
          <v-data-table
            :headers="headers"
            :items="stockAreas"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                label
                :color="item.status ? 'primary' : ''"
                :text-color="item.status ? 'white' : ''"
              >
                {{
                  item.status
                    ? $t("StockArea.status.on")
                    : $t("StockArea.status.off")
                }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      $router.push(
                        '/stocks/positions?stock_id=' +
                          item.stock_id +
                          '&stock_area_id=' +
                          item.id
                      )
                    "
                    >fa-external-link-alt</v-icon
                  >
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("StockArea.ObjectName")])
                }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt</v-icon
                  >
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("StockArea.ObjectName")])
                }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('StockAreas', 'edit')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = JSON.parse(JSON.stringify(item));
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{ $t("CRUD.editInfo", [$t("StockArea.title")]) }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="
                  $permission.permissionAllow('StockAreas', 'delete') &&
                  Number(item.deletable)
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="accent"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItem = JSON.parse(JSON.stringify(item));
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.deleteInfo", [$t("StockArea.title")])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <StockAreaDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getStockAreasFromAPI()"
    />
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('StockArea.ObjectName')"
      @confirm="
        del();
        deleteDialog = false;
      "
    />
  </div>
</template>
<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import { mapState } from "vuex";
import StockAreas from "@/api/stock_areas";
import Stocks from "@/api/stocks";
import StockAreaDetail from "./plugins/Detail";
import DialogDelete from "@/components/plugins/DialogDelete";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";

const defaultOptions = {
  keyword: "",
  stock_id: "",
};
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    StockAreaDetail,
    DialogDelete,
    SearcherKeyword,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stocks"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stockArea"),
          disabled: true,
          href: "/stocks/areas" + "?stock_id=" + this.stock_id,
        },
        {
          text: this.stock && this.stock.name ? this.stock.name : "",
          disabled: false,
          accent: true,
        },
      ];
    },
    headers: () => [
      {
        text: i18n.t("StockArea.Fields.stock_area_name"),
        align: "start",
        sortable: false,
        value: "area_name",
      },
      {
        text: i18n.t("StockArea.Fields.stock_area_code"),
        align: "start",
        sortable: false,
        value: "area_code",
      },
      {
        text: i18n.t("StockArea.Fields.status"),
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("StockArea.Fields.memo"),
        align: "start",
        sortable: false,
        value: "memo",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("stock_areas-options")
        ? sessionStorage.getItem("stock_areas-options")
        : JSON.stringify(defaultOptions)
    ),
    stock_id: 0,
    stock: {},
    searchFields: "",
    keyword: "",
    stockAreas: [],
    paging: {},
    currentItemMode: null,
    currentItem: null,
    deleteDialog: false,
  }),

  mounted() {
    if (this.$route.query.stock_id) {
      this.stock_id = this.$route.query.stock_id;

      //获取仓库信息
      Stocks.fetchOne(this.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
          }
        }.bind(this)
      );
    }
  },

  methods: {
    getStockAreasFromAPI() {
      StockAreas.fetch(this.options, { stock_id: this.stock_id }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockAreas = response.data.stock_areas;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    del() {
      StockAreas.del(this.currentItem.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getStockAreasFromAPI();
          }
        }.bind(this)
      );
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.stock_area_id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    options: {
      deep: true,
      handler() {
        this.getStockAreasFromAPI();
        sessionStorage.setItem(
          "stock_areas-options",
          JSON.stringify(this.options)
        );
      },
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$router.replace(
            "/stocks/areas?stock_id=" +
              this.stock_id +
              "&stock_area_id=" +
              this.currentItem.id
          );
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
          this.$router.replace("/stocks/areas?stock_id=" + this.stock_id);
        }
      },
    },
    stock_id: {
      handler() {
        if (this.stock_id) this.options.stock_id = this.stock_id;
      },
    },
  },
};
</script>